import { Component, OnInit } from '@angular/core';

const APP_STORE_URL = 'https://apps.apple.com/us/app/rosie-ai-business-receptionist/id6757593086';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.rosie.mobile';

@Component({
  selector: 'rosie-app-redirect',
  template: '',
  standalone: false,
})
export class AppRedirectComponent implements OnInit {
  ngOnInit(): void {
    const ua = navigator.userAgent || '';
    if (/iPad|iPhone|iPod/.test(ua)) {
      window.location.href = APP_STORE_URL;
    } else if (/Android/.test(ua)) {
      window.location.href = PLAY_STORE_URL;
    } else {
      window.location.href = APP_STORE_URL;
    }
  }
}
